import { FaGift } from "react-icons/fa";
import { StructureBuilder } from "sanity/structure";

export default (S: StructureBuilder) =>
  S.listItem()
    .title("Packages")
    .icon(FaGift)
    .child(S.documentTypeList("package"));
